/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import {
  PharmacyDailyOnlineCounselingSlot,
  PharmacyDailyOnlineCounselingSlotFromJSON,
  PharmacyDailyOnlineCounselingSlotToJSON,
  PharmacyDailyOnlineCounselingSlots,
  PharmacyDailyOnlineCounselingSlotsFromJSON,
  PharmacyDailyOnlineCounselingSlotsToJSON,
  PharmacyOnlineCounselingSlot,
  PharmacyOnlineCounselingSlotFromJSON,
  PharmacyOnlineCounselingSlotToJSON,
  PharmacyOnlineCounselingSlots,
  PharmacyOnlineCounselingSlotsFromJSON,
  PharmacyOnlineCounselingSlotsToJSON,
} from "../models";

export interface GetPharmacyDailyOnlineCounselingSlotsRequest {
  pharmacyId: number;
  from: string;
  to: string;
}

export interface GetPharmacyOnlineCounselingSlotsRequest {
  pharmacyId: number;
}

export interface UpdatePharmacyTemporaryOnlineCounselingSlotRequest {
  pharmacyId: number;
  date: string;
  body?: any | null;
}

export interface UpdatePharmacyWeekdayOnlineCounselingSlotRequest {
  pharmacyId: number;
  weekday: UpdatePharmacyWeekdayOnlineCounselingSlotWeekdayEnum;
  body?: any | null;
}

/**
 *
 */
export class PharmacyOnlineCounselingSlotsApi extends runtime.BaseAPI {
  /**
   * Get pharmacy daily online counseling slots
   */
  async getPharmacyDailyOnlineCounselingSlotsRaw(
    requestParameters: GetPharmacyDailyOnlineCounselingSlotsRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PharmacyDailyOnlineCounselingSlots>> {
    if (requestParameters.pharmacyId === null || requestParameters.pharmacyId === undefined) {
      throw new runtime.RequiredError(
        "pharmacyId",
        "Required parameter requestParameters.pharmacyId was null or undefined when calling getPharmacyDailyOnlineCounselingSlots."
      );
    }

    if (requestParameters.from === null || requestParameters.from === undefined) {
      throw new runtime.RequiredError(
        "from",
        "Required parameter requestParameters.from was null or undefined when calling getPharmacyDailyOnlineCounselingSlots."
      );
    }

    if (requestParameters.to === null || requestParameters.to === undefined) {
      throw new runtime.RequiredError(
        "to",
        "Required parameter requestParameters.to was null or undefined when calling getPharmacyDailyOnlineCounselingSlots."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.from !== undefined) {
      queryParameters["from"] = tzDate(requestParameters.from).format();
    }

    if (requestParameters.to !== undefined) {
      queryParameters["to"] = tzDate(requestParameters.to).format();
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/pharmacies/{pharmacy_id}/daily-online-counseling-slots`.replace(
          `{${"pharmacy_id"}}`,
          encodeURIComponent(String(requestParameters.pharmacyId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PharmacyDailyOnlineCounselingSlotsFromJSON(jsonValue));
  }

  /**
   * Get pharmacy daily online counseling slots
   */
  async getPharmacyDailyOnlineCounselingSlots(
    requestParameters: GetPharmacyDailyOnlineCounselingSlotsRequest,
    initOverrides?: RequestInit
  ): Promise<PharmacyDailyOnlineCounselingSlots> {
    return promiseRetry(
      (retry) =>
        this.getPharmacyDailyOnlineCounselingSlotsRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Get pharmacy online counseling slots
   */
  async getPharmacyOnlineCounselingSlotsRaw(
    requestParameters: GetPharmacyOnlineCounselingSlotsRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PharmacyOnlineCounselingSlots>> {
    if (requestParameters.pharmacyId === null || requestParameters.pharmacyId === undefined) {
      throw new runtime.RequiredError(
        "pharmacyId",
        "Required parameter requestParameters.pharmacyId was null or undefined when calling getPharmacyOnlineCounselingSlots."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/pharmacies/{pharmacy_id}/online-counseling-slots`.replace(
          `{${"pharmacy_id"}}`,
          encodeURIComponent(String(requestParameters.pharmacyId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PharmacyOnlineCounselingSlotsFromJSON(jsonValue));
  }

  /**
   * Get pharmacy online counseling slots
   */
  async getPharmacyOnlineCounselingSlots(
    requestParameters: GetPharmacyOnlineCounselingSlotsRequest,
    initOverrides?: RequestInit
  ): Promise<PharmacyOnlineCounselingSlots> {
    return promiseRetry(
      (retry) =>
        this.getPharmacyOnlineCounselingSlotsRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Update pharmacy temporary online counseling slot
   */
  async updatePharmacyTemporaryOnlineCounselingSlotRaw(
    requestParameters: UpdatePharmacyTemporaryOnlineCounselingSlotRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PharmacyDailyOnlineCounselingSlot>> {
    if (requestParameters.pharmacyId === null || requestParameters.pharmacyId === undefined) {
      throw new runtime.RequiredError(
        "pharmacyId",
        "Required parameter requestParameters.pharmacyId was null or undefined when calling updatePharmacyTemporaryOnlineCounselingSlot."
      );
    }

    if (requestParameters.date === null || requestParameters.date === undefined) {
      throw new runtime.RequiredError(
        "date",
        "Required parameter requestParameters.date was null or undefined when calling updatePharmacyTemporaryOnlineCounselingSlot."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/pharmacies/{pharmacy_id}/dates/{date}/temporary-online-counseling-slot`
          .replace(`{${"pharmacy_id"}}`, encodeURIComponent(String(requestParameters.pharmacyId)))
          .replace(`{${"date"}}`, encodeURIComponent(String(requestParameters.date))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.body as any,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PharmacyDailyOnlineCounselingSlotFromJSON(jsonValue));
  }

  /**
   * Update pharmacy temporary online counseling slot
   */
  async updatePharmacyTemporaryOnlineCounselingSlot(
    requestParameters: UpdatePharmacyTemporaryOnlineCounselingSlotRequest,
    initOverrides?: RequestInit
  ): Promise<PharmacyDailyOnlineCounselingSlot> {
    return promiseRetry(
      (retry) =>
        this.updatePharmacyTemporaryOnlineCounselingSlotRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Update pharmacy weekday online counseling slot
   */
  async updatePharmacyWeekdayOnlineCounselingSlotRaw(
    requestParameters: UpdatePharmacyWeekdayOnlineCounselingSlotRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PharmacyOnlineCounselingSlot>> {
    if (requestParameters.pharmacyId === null || requestParameters.pharmacyId === undefined) {
      throw new runtime.RequiredError(
        "pharmacyId",
        "Required parameter requestParameters.pharmacyId was null or undefined when calling updatePharmacyWeekdayOnlineCounselingSlot."
      );
    }

    if (requestParameters.weekday === null || requestParameters.weekday === undefined) {
      throw new runtime.RequiredError(
        "weekday",
        "Required parameter requestParameters.weekday was null or undefined when calling updatePharmacyWeekdayOnlineCounselingSlot."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/pharmacies/{pharmacy_id}/weekdays/{weekday}/online-counseling-slot`
          .replace(`{${"pharmacy_id"}}`, encodeURIComponent(String(requestParameters.pharmacyId)))
          .replace(`{${"weekday"}}`, encodeURIComponent(String(requestParameters.weekday))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.body as any,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PharmacyOnlineCounselingSlotFromJSON(jsonValue));
  }

  /**
   * Update pharmacy weekday online counseling slot
   */
  async updatePharmacyWeekdayOnlineCounselingSlot(
    requestParameters: UpdatePharmacyWeekdayOnlineCounselingSlotRequest,
    initOverrides?: RequestInit
  ): Promise<PharmacyOnlineCounselingSlot> {
    return promiseRetry(
      (retry) =>
        this.updatePharmacyWeekdayOnlineCounselingSlotRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}

/**
 * @export
 * @enum {string}
 */
export enum UpdatePharmacyWeekdayOnlineCounselingSlotWeekdayEnum {
  Sun = "sun",
  Mon = "mon",
  Tue = "tue",
  Wed = "wed",
  Thu = "thu",
  Fri = "fri",
  Sat = "sat",
}
